import CyclesList from './CyclesList';

export default CyclesList;
